import React from 'react'
import { PaginationItem } from './PaginationItem'

interface WrapperProps {
    ellipsesPosition: 'before' | 'after'
    path: string
    isDisabled: boolean
    onPageChange: (x: number) => void
    currentPage: number
    nextPage: number
}
export const WrapperPages = ({
    ellipsesPosition,
    path,
    isDisabled,
    onPageChange,
    currentPage,
    nextPage,
}: WrapperProps) => {
    return (
        <>
            {ellipsesPosition === 'before' && (
                <PaginationItem
                    text="..."
                    isDisabled={true}
                    layout={{
                        showText: true,
                        display: {
                            default: {
                                display: 'none',
                            },
                            sm: {
                                display: 'flex',
                            },
                        },
                    }}
                    onClick={() => {}}
                    routePath={path}
                    page={{ currentPage: 1, nextPage: 0 }}
                />
            )}
            <PaginationItem
                isDisabled={isDisabled}
                layout={{
                    showText: true,
                    display: {
                        default: {
                            display: 'none',
                        },
                        sm: {
                            display: 'flex',
                        },
                    },
                }}
                onClick={onPageChange}
                routePath={path}
                page={{ currentPage, nextPage }}
            />
            {ellipsesPosition === 'after' && (
                <PaginationItem
                    text="..."
                    isDisabled={true}
                    layout={{
                        showText: true,
                        display: {
                            default: {
                                display: 'none',
                            },
                            sm: {
                                display: 'flex',
                            },
                        },
                    }}
                    onClick={() => {}}
                    routePath={path}
                    page={{ currentPage: 1, nextPage: 0 }}
                />
            )}
        </>
    )
}
